import { Link } from 'react-router-dom';
import { Calendar, MapPin, Trophy, House } from '@phosphor-icons/react';

const fmt = (d) => {
  try { return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); }
  catch { return d; }
};

export default function EventCard({ event, compact = false }) {
  return (
    <Link
      to={`/events/${event.event_id}`}
      className="group block bg-card border border-border rounded-2xl overflow-hidden hover:border-turquoise hover:shadow-2xl hover:shadow-turquoise/10 transition-all hover:-translate-y-1"
      data-testid={`event-card-${event.event_id}`}
    >
      <div className="relative aspect-[16/10] bg-muted overflow-hidden">
        {event.hero_image ? (
          <img
            src={event.hero_image}
            alt={`${event.name} — ${event.tribe} pow wow in ${event.city}, ${event.state}`}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        ) : (
          <div className="w-full h-full pattern-aztec bg-muted" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-card/80 to-transparent opacity-60" />
        {event.featured && (
          <span className="absolute top-3 left-3 bg-gold text-navy text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full">
            Featured
          </span>
        )}
        {event.indoor && (
          <span className="absolute top-3 right-3 bg-card/90 text-turquoise text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full flex items-center gap-1 border border-border">
            <House size={12} weight="fill" /> Indoor
          </span>
        )}
      </div>
      <div className="p-5">
        <p className="label text-turquoise mb-1.5">{event.tribe}</p>
        <h3 className="font-display text-xl leading-tight text-foreground mb-2 group-hover:text-turquoise transition-colors">
          {event.name}
        </h3>
        <div className="space-y-1.5 text-sm text-muted-foreground">
          <p className="flex items-center gap-1.5">
            <Calendar size={14} weight="duotone" />
            {fmt(event.start_date)} {event.end_date !== event.start_date && `– ${fmt(event.end_date)}`}
          </p>
          <p className="flex items-center gap-1.5">
            <MapPin size={14} weight="duotone" />
            {event.city}, {event.state}
            {event.distance_miles !== undefined && (
              <span className="ml-auto text-xs font-semibold text-turquoise">{event.distance_miles} mi</span>
            )}
          </p>
        </div>
        {!compact && event.total_prize_pool > 0 && (
          <div className="mt-3 pt-3 border-t border-border flex items-center justify-between">
            <span className="text-xs text-muted-foreground flex items-center gap-1.5">
              <Trophy size={14} weight="duotone" className="text-gold" />
              Prize Pool
            </span>
            <span className="font-display text-lg text-gold font-semibold">
              ${event.total_prize_pool.toLocaleString()}
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}
